import React from "react";

 const tableData = [
  ["Messages"],
  ["Chat titles"],
  ["Messages"],
  ["Videos"],
  ["Pictures"],
  ["Files"],
  ["Voice messages and Voicemail"],
  ["Call recordings"],
  ["Video messages"],
];

 const tableData1 = [
  ["Subscription period + 7days past subscription"],
  ["Subscription period + 7days past subscription"],
  ["Subscription period + 7days past subscription"],
  ["Subscription period + 7days past subscription"],
  ["Subscription period + 7days past subscription"],
  ["Subscription period + 7days past subscription"],
  ["Subscription period + 7days past subscription"],
  ["Subscription period + 7days past subscription"],
  ["Subscription period + 7days past subscription"],
];

 const data = [
  "read your own contact card",
  "add or remove accounts",
  "find accounts on the device",
  "read your contacts",
  "modify your contacts",
  "use accounts on the device",
  "read sync statistics",
  "read sync settings",
  "toggle sync on and off",
  "create accounts and set passwords",
];

const ListItem = ({ title, isSmall }) => {
  return (
    <div className={`flex items-center gap-2 mb-2 ${isSmall && "mb-0"}`}>
      <p className="text-2xl">{"\u2022"}</p>
      <p className="text-sm text-gray-800">{title}</p>
    </div>
  );
};

const App = () => {
  return (
    <div>
      <div>
        <div className="px-4">
          <p className="text-gray-400">Version: 1.000</p>
          <p className="text-blue-400 font-semibold text-2xl tracking-widest">
            How are my contact details used in PlayInCase?
          </p>
          <p className="text-gray-600 mt-6 tracking-wide">
            You can have different contact details in your PlayInCase profile
            (which is used only in PlayInCase. PlayInCase uses some of these
            contact details, like your email address in different ways. In this
            article, we will describe how your PlayInCase profile information is
            used.
          </p>
          <p className="text-blue-400 font-semibold text-2xl tracking-widest mt-8">
            Item Type
          </p>
          {tableData.map((item, index) => (
            <p className="text-gray-600 mt-2 tracking-wide" key={index}>
              {item}
            </p>
          ))}
          <p className="text-blue-400 font-semibold text-2xl tracking-widest mt-8">
            Duration Available
          </p>
          {tableData1.map((item, index) => (
            <p className="text-gray-600 mt-2 tracking-wide" key={index}>
              {item}
            </p>
          ))}
          <p className="text-gray-600 mt-4 tracking-wide leading-6">
            These items are retained whilst you maintain your subscription,
            including seven days after the subscription lapses in order to
            provide time to re-subscribe, after the 7 day period these items are
            deleted
          </p>
          <p className="text-blue-400 font-semibold text-2xl tracking-widest mt-8">
            How long are files and data available in PlayInCase?
          </p>
          <p className="text-gray-600 mt-6 tracking-wide">
            PlayInCase stores videos you’ve recorded, files and photos you've
            shared, and other items for easy access across all of your devices
          </p>
          <p className="text-gray-600 mt-2 tracking-wide">
            Keep in mind that any items that have been deleted by you and your
            contact will no longer be available in your received/sent tabs or to
            export.
          </p>
          <p className="text-gray-600 mt-6 tracking-wide">
            *Messages, videos, video messages, and pictures are available until
            they are deleted or dated back to April 2017 and chat titles until
            deleted or users leave conversations.
          </p>
          <p className="text-gray-600 mt-6 tracking-wide">
            How does PlayInCase use the email address in my PlayInCase profile?
            In your PlayInCase profile, you need to have a primary email
            address. PlayInCase uses this email address primarily to send you
            important communications about your PlayInCase account. 
          </p>
          <p className="text-blue-400 font-semibold text-2xl tracking-widest mt-8">
            How do I remove an instant message or clear a conversation in
            PlayInCase?
          </p>
          <p className="text-gray-600 mt-4 tracking-wide">
            In PlayInCase you can remove an instant message you've sent in a
            message, delete a one-to-one conversation, or clear a group
            conversation.
          </p>
          <p className="text-blue-400 font-semibold text-2xl tracking-widest mt-8">
            Does PlayInCase use encryption?
          </p>
          <p className="text-gray-600 mt-4 tracking-wide">
            All PlayInCase, video, file transfers and instant messages are
            stored on Amazon S3 and encrypted when stored and retrieved. This
            protects you from potential eavesdropping by malicious users.
          </p>
          <p className="text-blue-400 font-semibold text-2xl tracking-widest mt-8">
            Protecting your online safety, security and privacy
          </p>
          <p className="text-gray-600 mt-4 tracking-wide">
            The following guidance is specific to PlayInCase’s consumer software
            applications and products.
          </p>
          <p className="mt-4 font-bold">
            What you can do to stay safe
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            If you have found a security vulnerability in our
            PlayInCase application or online services, please report it via this
            email security@playincase.com.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            The following items outline things you can do to help keep your
            account secure. Passwords
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            It’s important that you choose a secure password to access your
            PlayInCase account. Hackers use lists of common passwords to access
            accounts (not only on PlayInCase but across all websites), so it’s
            critical that you use a strong, unique password.
          </p>
          <div className="mt-4">
            <ListItem title="Use a mixture of letters, numbers and characters – like the characters above the numbers on many keyboards such as %, *,$, £ and !. Including in your password punctuation, symbols and other non-standard characters helps to increase the strength of your password." />
            <ListItem title="Avoid names, birthdays and dictionary words, as these are easy to guess and hack." />
            <ListItem title="The longer the password is, the stronger it usually is – but the harder it is to recall. Choose a password you can remember so that you don’t have to write it down." />
          </div>
          <p className="text-gray-600 tracking-wide">
            It can be difficult to create a strong password and remember it
            easily. Here are a few techniques to help:
          </p>
          <p className="mt-4 font-bold">
            Use a sentence as your password
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Passwords are limited to 50 characters, but you can use a short
            sentence to create a password that’s difficult to crack.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Include numbers, uppercase and lowercase letters in your passwords,
            so instead of "theanswerismars" try "Th3Answer1sM4rs*"
          </p>
          <p className="mt-4 font-bold">
            Make the password personal to you
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Your password is something that only you should know and not
            something that someone else could easily find out. For example, the
            name of your dog or your favorite movie are things that others might
            know – especially since, with the advent of social networking, a lot
            of personal information is available about you.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Try looking outside and describing something you see ("The River
            Flowing!" or "A Yellow car"), and then apply our recommendations:
            "Th3Riv3rFl0wing*" or "4Y3lloWcar.$"
          </p>
          <p className="mt-4 font-bold">
            Use a unique password for each site
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Many of us have a large number of websites and accounts that we need
            to remember our username and password for, but not all sites are
            created equal. Whilst we at PlayInCase care passionately about and
            invest heavily in your security, not all sites do. So use a password
            that is unique to each website you use to prevent any compromise of
            those other sites from affecting your PlayInCase account.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            It's common practice for attackers to verify stolen accounts from
            other websites against high-value accounts like PlayInCase, mail
            providers and social networks to see if they can get access.
          </p>
          <p className="mt-4 font-bold">
            Change your password regularly
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Even if you have a strong password, you should change it regularly.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            And if you ever suspect your password has been compromised, you
            should change it immediately.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            If another website or service where you use the same or a similar
            password is compromised, change your PlayInCase password as soon as
            possible to protect your account.
          </p>
          <p className="mt-4 font-bold">
            Use a unique password for each site
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Many of us have a large number of websites and accounts that we need
            to remember our username and password for, but not all sites are
            created equal. Whilst we at PlayInCase care passionately about and
            invest heavily in your security, not all sites do. So use a password
            that is unique to each website you use to prevent any compromise of
            those other sites from affecting your PlayInCase account.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            It's common practice for attackers to verify stolen accounts from
            other websites against high-value accounts like PlayInCase, mail
            providers and social networks to see if they can get access.
          </p>
          <p className="mt-4 font-bold">
            Change your password regularly
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Even if you have a strong password, you should change it regularly.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            And if you ever suspect your password has been compromised, you
            should change it immediately.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            If another website or service where you use the same or a similar
            password is compromised, change your PlayInCase password as soon as
            possible to protect your account.
          </p>
          <p className="mt-4 font-bold">
            Protecting your computer
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Viruses can damage your computer and collect your private data,
            regardless of whether or not you are using PlayInCase. To avoid
            this, follow these tips:
          </p>
          <div className="mt-4">
            <ListItem title="Don't open any email attachments from people you don't know, or suspicious-looking attachments even from people you know. When in doubt, always contact the person who sent you the email to confirm it's legitimate, even if it looks harmless (such as an e-card or funny picture) at first sight." />
            <ListItem title="Always use an antivirus program to check the files you receive from other people, whether on PlayInCase or any other method, even if you know the sender. Keep your antivirus software up-to-date and running at all times." />
            <ListItem title="Use a personal firewall." />
            <ListItem title="Make sure you've set up your computer to regularly receive the latest security updates and patches for your operating system  (e.g. Microsoft Windows or Apple Mac OS X) and for applications such as Adobe Flash, Microsoft Internet Explorer or Mozilla Firefox." />
            <ListItem title="Be careful which sites you choose to visit and download content from. Always use the official site." />
          </div>
          <p>
            Visit  <p className="underline text-blue-600">InSafe</p>  or 
            <p className="underline text-blue-600">Get Safe Online</p> for more
            information on using the internet securely. (PlayInCase is not
            responsible for the content of external websites.)
          </p>
          <p className="mt-4 font-bold">
            Keeping PlayInCase up-to-date
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            PlayInCase is always making improvements, such as enhanced quality,
            better reliability, and improved security.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Always be very wary of any emails purporting to be from PlayInCase
            saying a security update is available - we will NEVER do this.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            You should only download PlayInCase from 
            <a href="https://www.playincase.com " className="underline text-blue-600">
              https://www.playincase.com 
            </a>
            (or from the App or Play Store stores on mobile) – we don’t
            distribute PlayInCase through any other site.
          </p>
          <p className="mt-4 font-bold">
            Avoiding online fraud 
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Always ensure you trust a website or merchant before giving your
            credit card information to any site that claims to be reselling
            PlayInCase products.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Never reply to emails that request your credit card details,
            password or other data. PlayInCase will NEVER request such data by
            email. Our Customer Service agents may request your payment/order
            details or ticket tracking numbers, but they will never request your
            full credit card data or password.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            You can report illegal resellers or parties misrepresenting
            themselves as PlayInCase by emailing security@playincase.com
          </p>
          <p className="mt-4 font-bold">
            Phishing
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Phishing is the attempt by a malicious third party to acquire
            sensitive information like a username, password or credit card
            details, by pretending to be a trusted company or website.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            For example, someone could send you an email pretending to be from
            PlayInCase asking you to click on a link and sign in to your
            account. The link might direct you to a fake website with the same
            look and feel as PlayInCase, but the personal information you enter
            there can be stored or stolen and used for malicious purposes.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            The best defense against phishing is vigilance. Whilst spam and
            other filters are increasingly effective, some phishing emails may
            still get through. By increasing your awareness of phishing
            techniques, and your alertness in acting upon them, you can take
            simple steps to defeat their attempts.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Beware of emails with a false sense of urgency, for example "Your
            account has been compromised, click here to view details", or an
            imperative like “Confirm your account details”. If you receive an
            email asking you to perform an action on your account, do not follow
            the links in the email. Instead, type PlayInCase.com into your
            browser and go to your account directly from the PlayInCase website.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            If you receive an email claiming to be from PlayInCase that has an
            attachment, do not open the attachment.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            If you arrive at a website through a link or other redirection, make
            sure that it says PlayInCase.com in the URL and does not contain
            within the web address additional characters or words. For instance,
            notPlayInCase.com or PlayInCase1.com are both invalid web addresses.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            And remember, if you think or even suspect that your account has
            been compromised, you should change your password immediately.
          </p>
          <p className="text-blue-400 font-semibold text-2xl tracking-widest mt-8">
            Your Permission, please? Android permission requests explained
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            You're ready to install PlayInCase and start chatting when suddenly
            you’re asked to give your permission to a whole list of things. This
            might seem a bit troubling, after all it’s not easy to understand
            exactly what you’re giving permission for. PlayInCase is designed to
            take full advantage of the hardware and software on your Android
            device.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            We won’t ask for permission to access your precise location.
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Here’s a list of all the Android possible permissions and what they
            mean to you:
          </p>

          <p className="text-blue-400 font-semibold text-2xl tracking-widest mt-8">
            Permission Category
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">Identity, Contacts</p>
          <p className="text-blue-400 font-semibold text-2xl tracking-widest mt-8">
            Permission
          </p>
          <div className="mt-4">
            {data.map((item, index) => (
              <ListItem key={index} title={item} isSmall={true} />
            ))}
          </div>
          <p className="text-blue-400 font-semibold text-2xl tracking-widest mt-8">
            Use
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            {`Enables PlayInCase to manage PlayInCase accounts in Android’s centralized account management system (Settings > Accounts)`}
          </p>
          <p className="text-blue-400 font-semibold text-2xl tracking-widest mt-8">
            What should I do if spam messages or links are sent from my account?
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            Some PlayInCase customers have reported that their accounts have
            been used to send spam instant messages to their contacts. Spam
            messages include links to sites such as Baidu, LinkedIn and other
            popular services. If you think your PlayInCase account has been
            hacked in this way, reset your PlayInCase password. The following
            steps will also help to secure your account.
          </p>
          <p className="mt-4 font-bold">
            Protect your account from spammers
          </p>
          <p className="text-gray-600 mt-3 tracking-wide">
            We believe hackers have illegally obtained username and password
            combinations used on other websites and then tried using them to
            sign in to PlayInCase. If you re-use credentials on different sites
            and services, then just one attack on one of these sites can
            compromise those credentials everywhere else. That’s why we
            recommend you use a unique username and password combination.
          </p>
        </div>
      </div>
    </div>
  );
};

export default App;
